



























































































































































// vue
import { defineComponent, computed, ref } from '@vue/composition-api';
import { useStore } from '@/store';

// services
import { useService } from '@/vue3/api/services';

// primevue
import Galleria from 'primevue/galleria';
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import Confirm from '@/vue3/components/Confirm.vue';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';

// lib
import { Portal } from '@linusborg/vue-simple-portal';

// hooks
import { useNotify } from '@/vue3/hooks/notifyHook';

// model
import { GeoRecordImageData } from '@/vue3/api/models';

export default defineComponent({
    components: {
        Galleria,
        Button,
        ProgressSpinner,
        Portal,
        Confirm,
        Dialog,
        InputText,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        updateAndRefreshGeoRecord: {
            type: Function,
            default: () => {},
        },
        isModifyAllowed: {
            type: Boolean,
            default: true,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // hooks
        const { errorToast } = useNotify();

        // services
        const { createGeoRecordImages, deleteGeoRecordImage } = useService();

        // store
        const store = useStore();
        const { apiUrl } = store.state;

        // refs
        const geoRecordImageData = ref<GeoRecordImageData>({
            name: '',
            id: 0,
        });
        const isDeleteVisible = ref(false);
        const isDeleteLoading = ref(false);
        const selectedImage = ref('');

        // properties
        const responsiveOptions2 = [
            {
                breakpoint: '1500px',
                numVisible: 5,
            },
            {
                breakpoint: '1024px',
                numVisible: 3,
            },
            {
                breakpoint: '768px',
                numVisible: 2,
            },
            {
                breakpoint: '560px',
                numVisible: 1,
            },
        ];

        const activeIndex = ref(0);

        const displayBasic = ref(false);
        const displayBasic2 = false;
        let displayCustom = false;

        // reactive
        const arr = ref<any[]>([]);

        // computed
        const geoRecordImages = computed(() => {
            if (props.geoRecord.imageSrc) {
                return [...props.geoRecord.imageSrc];
            }
        });

        const images = computed(() => {
            arr.value = [];

            if (geoRecordImages.value === undefined) {
                return [];
            }

            if (geoRecordImages.value.length > 0) {
                geoRecordImages.value.forEach((image, i) => {
                    const fileExtension = image.filename.split('.').pop();

                    arr.value.push({
                        itemImageSrc: `${apiUrl}/${image.filename}`,
                        thumbnailImageSrc: `${apiUrl}/${image.filename}`,
                        imageName: `${image.filename}`,
                        alt: i + 'image',
                        itemImageDate: new Date(image.modifyDate)
                            .toISOString()
                            .split('T')[0],
                        itemImageType: fileExtension,
                    });
                });
            }
            return arr.value;
        });

        const uploadImages = async (event: Event) => {
            isDeleteLoading.value = true;

            const target = event.target as HTMLInputElement;
            const files = target.files ? Array.from(target.files) : [];

            const currentImageCount = geoRecordImages.value
                ? geoRecordImages.value.length
                : 0;

            if (currentImageCount + files.length > 20) {
                errorToast('You can only upload a maximum of 20 images.');
                isDeleteLoading.value = false;
                return;
            }

            for (const file of files as File[]) {
                if (file.size > 12000000) {
                    errorToast(`${file.name} is too large`);
                    continue;
                }

                const formData = new FormData();
                formData.append('image', file, file.name);

                try {
                    await createGeoRecordImages(props.geoRecord.id, formData);
                } catch (error) {
                    errorToast(`Error uploading ${file.name}`);
                    console.error(error);
                }
            }

            props.updateAndRefreshGeoRecord();
            isDeleteLoading.value = false;
        };

        const imageClick = (index: number) => {
            activeIndex.value = index;
            displayCustom = true;
        };

        const getPrettyDate = (date: Date) => {
            if (date.toString() === new Date(0).toString()) {
                return;
            }
            return (
                date.getDate() +
                '/' +
                (date.getMonth() + 1) +
                '/' +
                date.getFullYear()
            );
        };

        const deleteImage = async () => {
            isDeleteLoading.value = true;
            var imageName = selectedImage.value.replace('image/', '');
            var remove_after = imageName.indexOf('/');
            imageName = imageName.substring(remove_after + 1, imageName.length);
            try {
                geoRecordImageData.value.name = imageName;
                geoRecordImageData.value.id = props.geoRecord.id;
                store.getters.currentOrganization.id;
                await deleteGeoRecordImage(geoRecordImageData.value);
            } catch (error) {
                window.console.log(error);
            }
            isDeleteLoading.value = false;
            isDeleteVisible.value = false;
            props.updateAndRefreshGeoRecord();
        };

        const deleteImageConfirmation = (image: any) => {
            isDeleteVisible.value = true;
            selectedImage.value = image.imageName;
        };

        const confirmDeleteImage = () => {
            deleteImage();
        };

        const confirmDecline = () => {
            isDeleteVisible.value = false;
        };

        const changeImageDate = (image: any): void => {
            const geoImage = props.geoRecord.imageSrc.find(
                (img: any) => img.filename === image.imageName,
            );

            if (geoImage) {
                geoImage.modifyDate = image.itemImageDate;
            }
        };

        const openGallery = (index: number) => {
            activeIndex.value = index;
            displayBasic.value = true
        }

        return {
            images,
            uploadImages,
            responsiveOptions2,
            activeIndex,
            displayBasic,
            displayBasic2,
            displayCustom,
            imageClick,
            getPrettyDate,
            geoRecordImages,
            deleteImage,
            deleteImageConfirmation,
            isDeleteVisible,
            isDeleteLoading,
            confirmDeleteImage,
            confirmDecline,
            changeImageDate,
            openGallery,
        };
    },
});
